import { ApplicationRef } from '@angular/core';

/** Production and ordinary development builds expose no browser automation bridge. */
export function installE2eBrowserBridges(_appRef: ApplicationRef): void {}
